require('./accountDirectDebitPartialSuccess.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const WizardError = require('components/commons/wizardError/wizardError');
const { OKMessage } = require('commonsComponents/OKMessage');

class AccountDirectDebitPartialSuccess extends React.Component {
    createList() {
        const { filesAttached } = this.props;
        let list;
        const items = filesAttached.map((file, ind) => {
            const fileError = !!file.get('error');
            const rowrClasses = classNames(
                'account-direct-debit-partial-success__file-list-item',
                'row',
                {'account-direct-debit-partial-success__file-list-item--error' : fileError}
            );
            const fileStatus = fileError ? 'fileNotSent' : 'fileSent';
            const fileName = file.get('name');
            return (
                <li key={ind} className={rowrClasses}>
                    <span className="account-direct-debit-partial-success__file-name col-xs-6">
                        {fileName}
                    </span>
                    <span className="account-direct-debit-partial-success__file-status col-xs-6">
                        <FormattedText value={`accountDirectDebitPartialSuccess-${fileStatus}`}/>
                    </span>
                </li>
            );
        });
        if (items.size > 0) {
            list = (
                <ul className="account-direct-debit-partial-success__file-list">
                    {items}
                </ul>
            );
        }
        return list;
    }

    render() {
        const { immAccount } = this.props;
        const goBackButtonLabel = formatText('accountDirectDebitPartialSuccess-mainButton').toUpperCase();
        const accountId = immAccount.get('accountId');
        const linkToDetails = `/myprofile/accounts/${accountId}/debits`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <div className="account-direct-debit-partial-success col-xs-9 center-block">
                <WizardError
                    errorMessage={formatText('accountDirectDebitPartialSuccess-title')}
                    mainButton={mainButton}
                >
                    <div className="account-direct-debit-partial-success__content">
                        <FormattedText value="accountDirectDebitPartialSuccess-content"/>
                        {this.createList()}
                        <OKMessage type="informative">
                            <FormattedText value="accountDirectDebitPartialSuccess-information"/>
                        </OKMessage>
                    </div>
                </WizardError>
            </div>
        );
    }
}

AccountDirectDebitPartialSuccess.propTypes = {
    filesAttached: PropTypes.object,
    immAccount: PropTypes.object.isRequired
};

module.exports = AccountDirectDebitPartialSuccess;
